import { toast } from 'react-toastify';
import appApi from '../../../api/app-api';
import { CourseFullInfo } from '../../../api/types/programs/course/course-info';
import { CourseMetadataType } from '../../../api/types/programs/course/course-metadata.type';
import AppApi from '../../../api/app-api';
import globalCourseStore from '../../../stores/global-course-store';

export const updateCourseNotesOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  notes: string,
  setLoading: (loading: boolean) => any,
) => {
  try {
    if (isNaN(Number(programId)) || isNaN(Number(courseId))) {
      toast.warn(
        'לא ניתן לאתר את מזהה התוכנית או הקורס המבוקש, נסה שוב בעוד מספר רגעים',
      );
      return;
    }
    setLoading(true);
    await appApi.updateCourseNotes(programId!, courseId!, notes);

    await globalCourseStore.fetchCourseDetails(programId!, courseId!);
    toast.success('ההערות עודכנו בהצלחה');
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(`updateCourseNotesOperation is failed with the error: ${e}`);
    toast.error('עדכון ההערות נכשל, נסה שוב בעוד מספר רגעים');
  }
};
